// Filename starts with "z" to ensure it runs after all other plugins are loaded
import { customerCookieName } from '~/enums/cookieNameEnum'

export default defineNuxtPlugin(async (nuxtApp) => {
  usePageStore()
  const customerStore = useCustomerStore()
  const { isLoggedIn } = storeToRefs(customerStore)
  const { loadCustomer } = customerStore
  const { getSegmentations } = useExponeaStore()
  const { setAbTests } = useAbTestStore()
  const productStore = useProductStore(nuxtApp.pinia)
  const { addToWishlistAfterLogin, loadWishlistIds } = useWishlistStore()
  const { loadTotalQty: loadCartTotalQty } = useCart()
  const logger = useAppLogger('Initialization')
  //set cookies
  const { $i18n } = useNuxtApp()
  const { init: initGTM } = useGTMComposable()
  const storeCookie = useCookie('vsf-store')
  const localeCookie = useCookie('vsf-locale')
  const countryCookie = useCookie('vsf-country')
  const currencyCookie = useCookie('vsf-currency')

  // Load server side
  await callOnce('getAttributes', () => productStore.getAttributes())

  // Loads on "mounted", so only on client side
  const setIntialState = async () => {
    const route = useRoute()
    const customerCookie = useCookie(customerCookieName)

    const platform = useState('platform')
    const isApp = platform.value === 'iOS' || platform.value === 'Android'

    if (isApp && route.query.customerToken) {
      customerCookie.value = route.query.customerToken as string
    }

    initGTM()
    await setAbTests()

    try {
      await loadCustomer()
    } catch (e) {
      if (isApp && route.query.customerToken && !isLoggedIn.value) {
        showError({
          status: 401,
          message: 'Invalid customer token. App could not login',
        })
        logger.error('Invalid customer token. App could not login')
      } else {
        throw e
      }
    }

    getSegmentations()
    addToWishlistAfterLogin()
    loadCartTotalQty()

    if (isLoggedIn.value) {
      loadWishlistIds()
    }
    storeCookie.value = `con_${$i18n.locale.value.substring(0, 2)}`
    localeCookie.value = $i18n.locale.value
    countryCookie.value = $i18n.locale.value
    currencyCookie.value = $i18n.localeProperties.value.defaultCurrency
  }

  nuxtApp.hook('app:mounted', () => setIntialState())
})
